///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const WarningIcon = ({
  height,
  fill = "#C71E0C",
  title = messages.warning.defaultMessage,
  width
}) => (
  <svg aria-labelledby="warning-icon" height={height} width={width} fill="none">
    <title id="warning-icon">{title}</title>
    <path
      fill={fill}
      d="M1.667 35h36.666L20 3.333 1.666 35Zm20-5h-3.334v-3.333h3.334V30Zm0-6.667h-3.334v-6.666h3.334v6.666Z"
    />
  </svg>
);

export default WarningIcon;
